<div id="openExtendsGuests" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Registrar Húesped</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
      </div>
      <app-loading-modal></app-loading-modal>
      <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-4">
                  <label>Grupo Edad<span class="required"></span></label>
                  <select class="form-control" formControlName="age_group">
                    <option *ngFor="let item of age_groups" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-4">
                  <label>Tipo documento<span class="required"></span></label>
                  <select class="form-control" formControlName="typedocument_id" (change)="changeTypeDocument()">
                    <option *ngFor="let item of typesdocument" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-4">
                  <label>N° Documento<span class="required"></span>
                    <ng-container *ngIf="typeDocumentSelected != null">
                      <span class="badge badge-info m-l-15"> {{typeDocumentSelected.max_length_document}} dígitos</span>
                    </ng-container>
                  </label>
                  <div class="input-group" *ngIf="typeDocumentSelected != null">
                    <input type="text" class="form-control" id="client_document" formControlName="document"
                      maxlength="{{typeDocumentSelected.max_length_document}}" required autofocus>
                    <div class="input-group-append bg-custom" *ngIf="typeDocumentSelected.id == documentRuc.id">
                      <div class="input-group-text pointer btn-sunat" (click)="extractRuc()" data-toggle="tooltip"
                        data-placement="right" data-original-title="Extraer de Sunat"></div>
                    </div>
                    <div class="input-group-append bg-custom" *ngIf="typeDocumentSelected.id == documentDni.id">
                      <div class="input-group-text pointer btn-reniec" (click)="extractDni()" data-toggle="tooltip"
                        data-placement="right" data-original-title="Extraer de Reniec"></div>
                    </div>
                  </div>
                  <div *ngIf="submitted && f['document'].errors">
                    <small class="text-danger" *ngIf="f['document'].errors['required']">Campo requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-12">
                  <label>Nombres y apellidos<span class="required"></span></label>
                  <input type="text" id="client_fullname" class="form-control" formControlName="fullname" required>
                  <div *ngIf="submitted && f['fullname'].errors">
                    <small class="text-danger" *ngIf="f['fullname'].errors['required']">Campo requerido</small>
                  </div>
                </div>

                <div class="form-group col-lg-4">
                  <label>País origen</label>
                  <ng-autocomplete #searchInputCountry [class]="'search-small search-brand'" [data]="countries"
                    [initialValue]="initialCountry" [searchKeyword]="'nombrepais'" placeholder="Seleccionar país"
                    (selected)='selectCountry($event)' (inputCleared)='clearedSearchCountry()'
                    [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate">
                  </ng-autocomplete>
                  <ng-template #itemTemplate let-item>
                    <a style="padding: 8px 15px;" class="f-s-12 p-10" [innerHTML]="item.nombrepais"></a>
                  </ng-template>
                  <ng-template #notFoundTemplate let-notFound>
                    <p class="p-t-5 m-b-5 bold">No se encontraron registros</p>
                  </ng-template>
                </div>
                <div class="form-group col-lg-4">
                  <label>Departamento <span *ngIf="required_ubigeo" class="required"></span></label>
                  <select class="form-control" [(ngModel)]="departmentSelected" (change)="changeDepartment()"
                    [ngModelOptions]="{standalone: true}">
                    <option value="0">Seleccione</option>
                    <option *ngFor="let item of departments" [value]="item.code">{{ item.name }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-4">
                  <label>Provincias<span *ngIf="required_ubigeo" class="required"></span></label>
                  <select class="form-control" [(ngModel)]="provinceSelected" (change)="changeProvince()"
                    [ngModelOptions]="{standalone: true}">
                    <option value="null">Seleccione</option>
                    <ng-container *ngIf="provinces.length > 0">
                      <option *ngFor="let item of provinces" [value]="item.code">{{ item.name }}</option>
                    </ng-container>
                  </select>
                </div>
                <div class="form-group col-lg-4">
                  <label>Distritos <span *ngIf="required_ubigeo" class="required"></span></label>
                  <select class="form-control" id="districtSelected" formControlName="ubigeo">
                    <option value="null">Seleccione</option>
                    <ng-container *ngIf="districts.length > 0">
                      <option *ngFor="let item of districts" [value]="item.code">{{ item.name }}</option>
                    </ng-container>
                  </select>
                </div>
                <div class="form-group col-lg-4">
                  <label>Sexo</label>
                  <select class="form-control" id="sexSelected" formControlName="sex">
                    <option *ngFor="let item of sexs" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-4">
                  <label>Fecha nacimiento</label>
                  <input type="date" id="date_birthday" class="form-control" placeholder="yy-mm-dd"
                    formControlName="date_birthday">
                </div>
              </div>
              <!-- <div class="row">
                <div class="form-group col-lg-6 m-t-15">
                  <label>Adjuntar copia documento</label>
                  <input id="fileUrl" type="file" accept="image/png, image/jpeg, image/jpg"
                    (change)="onFileSelected($event)">
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal"
            (click)="close()">Cancelar</button>
          <button type="submit" class="btn btn-primary">
            <i class="far fa-save m-r-5"></i>
            Guardar
            <ng-container *ngIf="isEdit">
              Cambios
            </ng-container>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
